import dayjs from 'dayjs';

export const THREAD_RESPONSE_TYPES = {
  DEFAULT_5_MINUTES: 'default',
  NO_ESTIMATE: 'no_estimate',
  CUSTOM: 'custom'
};

export const RESPONSE_TYPES = [
  {
    id: THREAD_RESPONSE_TYPES.DEFAULT_5_MINUTES,
    label: '5 minutes (Matches the “Swarm Mode” response timer in Inbox)'
  },
  {
    id: THREAD_RESPONSE_TYPES.NO_ESTIMATE,
    label: 'No estimate (no time will be shown to the customer)'
  },
  {
    id: THREAD_RESPONSE_TYPES.CUSTOM,
    label: 'Custom'
  }
];

export const covertMinutesToDayjs = minutes => {
  return dayjs()
    .startOf('day')
    .add(minutes || 0, 'minute');
};

export const convertDayjsToMinutes = dayjsTime => {
  if (!dayjsTime) return 0;
  return dayjsTime.hour() * 60 + dayjsTime.minute();
};
